"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var validate_exports = {};
__export(validate_exports, {
  assertStepCountListener: () => assertStepCountListener,
  assertStepCountRange: () => assertStepCountRange
});
module.exports = __toCommonJS(validate_exports);
function assertStepCountListener(listener) {
  if (typeof listener !== "function") {
    throw new Error("Pedometer.watchStepCount: listener must be a function");
  }
}
function assertStepCountRange(start, end) {
  if (!(start instanceof Date) || !(end instanceof Date)) {
    throw new Error("Pedometer.getStepCount: start and end must be Dates");
  }
  if (!Number.isFinite(start.getTime()) || !Number.isFinite(end.getTime())) {
    throw new Error("Pedometer.getStepCount: start and end must be valid dates");
  }
  if (start.getTime() > end.getTime()) {
    throw new Error("Pedometer.getStepCount: start must precede end");
  }
}
//# sourceMappingURL=validate.js.map
